module.exports = __webpack_public_path__ + "static/bsas004.thumb-b3c658ca0a0e26e6b1869c20ead3de39.jpg";